// onProgress (optional) is called with the task object on every poll so callers can show progress.
export async function awaitTask(url, options = {}, pingInterval = 5000, onProgress = null) {
  const response = await fetch(url, options);

  let data;
  const text = await response.text();
  try {
    data = JSON.parse(text);
  } catch (e) {
    console.error('Initial response for awaitTask was not valid json', { url, text });
    throw e;
  }

  if (!response.ok) {
    const message = Array.isArray(data) ? data.join(' ') : (data?.detail || data?.error);
    const error = new Error(message || response.statusText);
    error.response = data;
    throw error;
  }

  const taskId = data.task_id;

  const result = await new Promise(async (resolve, reject) => {
    let interval;

    const checkStatus = async () => {
      const response = await fetch(`/api/v1/tasks/${taskId}/`, {
        method: 'GET',
        headers: options.headers,
      });
      const data = await response.json();

      if (typeof onProgress === 'function' && data.task) {
        onProgress(data.task);
      }

      if (data.task?.status === 'failed') {
        clearInterval(interval);
        reject(data);
        return;
      }

      if (data.task?.status === 'complete') {
        clearInterval(interval);
        resolve(data);
        return;
      }
    };

    // Call immediately to check the status
    await checkStatus();

    interval = setInterval(checkStatus, pingInterval);
  });

  return result;
}
